<template>
    <div class="de-table-wrap noheating">
        <div class="de-table-lt">
            <div class="de-table-top">
                <span class="line-80" style="line-height: 80px">排放数据</span>
            </div>
            <div class="de-table-bot">
                <span class="line-410" style="line-height: 410px">减排措施</span>
            </div>
        </div>
        <div class="de-table-ct">
            <div class="de-table-top">
                <div class="de-table-top-head">
                    <span class="line-30" style="line-height: 30px">排放物质</span>
                </div>
                <div class="de-table-top-list">
                    <span class="line-40" style="line-height: 40px">企业日排放量</span>
                </div>
            </div>
            <div class="de-table-bot">
                <div class="de-table-bot-head">
                    <div class="de-table-col flex125">
                        <span class="line-25" style="line-height: 25px">级别</span>
                    </div>
                    <div class="de-table-col flex5">
                        <span  class="line-25" style="line-height: 25px">措施详情</span>
                    </div>
                    <div class="de-table-col bd-none flex1">
                        <span class="line-25" style="line-height: 25px">重型车停运</span>
                    </div>
                </div>
                <div class="de-table-bot-con">
                    <div class="de-table-col flex125">
                        <div class="de-table-row">
                            <span class="line-100" style="line-height: 100px">III级黄色预警</span>
                        </div>
                        <div class="de-table-row">
                            <span class="line-100" style="line-height: 100px">II级橙色预警</span>
                        </div>
                        <div class="de-table-row">
                            <span class="line-100" style="line-height: 100px">I级红色预警</span>
                        </div>
                    </div>
                    <div class="de-table-col flex5">
                        <div class="de-table-row" v-for="(item30,index) in currentStrategy_three.measure" :key="'30'+index">
                            <span>
                              <el-input style="height:100% !important; padding:0px;" placeholder="请输入详细减排措施(限制1000字)" type="textarea" resize="none" :rows="3"  :autosize="{ minRows: 2, maxRows: 3}" :maxlength="1000" v-model="item30.method" size="small" clearable> </el-input>
                          </span>
                        </div>
                        <div class="de-table-row" v-for="(item31,index) in currentStrategy_two.measure" :key="'31'+index">
                            <span>
                                <el-input style="height:100% !important; padding:0px;" placeholder="请输入详细减排措施(限制1000字)" type="textarea" resize="none" :rows="3" :autosize="{ minRows: 2, maxRows: 3}" :maxlength="1000" v-model="item31.method" size="small" clearable> </el-input>
                          </span>
                        </div>
                        <div class="de-table-row" v-for="(item32,index) in currentStrategy_one.measure" :key="'32'+index">
                            <span>
                                <el-input style="height:100% !important; padding:0px;" placeholder="请输入详细减排措施(限制1000字)" type="textarea" resize="none" :rows="3"  :autosize="{ minRows: 2, maxRows: 3}" :maxlength="1000" v-model="item32.method" size="small" clearable> </el-input>
                          </span>
                        </div>
                    </div>
                    <div class="de-table-col bd-none flex1">
                        <div class="de-table-row" v-for="(item6,index) in currentStrategy_three.measure" :key="'06'+index">
                            <span class="line-100" style="line-height: 100px;">
                          <el-switch v-model="item6.isVehicleControl" on-text="" size="small" off-text="" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                        </span>
                        </div>
                        <div class="de-table-row" v-for="(item7,index) in currentStrategy_two.measure" :key="'07'+index">
                            <span class="line-100" style="line-height: 100px;">
                          <el-switch v-model="item7.isVehicleControl" on-text="" size="small" off-text="" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                        </span>
                        </div>
                        <div class="de-table-row" v-for="(item8,index) in currentStrategy_one.measure" :key="'08'+index">
                            <span class="line-100" style="line-height: 100px;">
                          <el-switch v-model="item8.isVehicleControl" on-text="" size="small" off-text="" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                        </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="de-table-rt">
            <div class="de-table-top">
                <div class="de-table-top-head">
                    <div class="de-table-col">
                        <span class="line-30" style="line-height: 30px">二氧化硫(kg)</span>
                    </div>
                    <div class="de-table-col">
                        <span class="line-30" style="line-height: 30px">烟、粉尘(kg)</span>
                    </div>
                    <div class="de-table-col">
                        <span class="line-30" style="line-height: 30px">氮氧化物(kg)</span>
                    </div>
                    <div class="de-table-col">
                        <span class="line-30" style="line-height: 30px">VOCs(kg)</span>
                    </div>
                    <div class="de-table-col">
                        <span class="line-30" style="line-height: 30px">总计(kg)</span>
                    </div>
                </div>
                <div class="de-table-top-list">
                    <div class="de-table-col">
                        <span class="line-40" style="line-height: 40px">
                        <el-input type="number" v-model.number="entpHeavyPollInfo.emissionSO2" :min="1" @change="numberChange" size="small" style="width:80px;"></el-input>
                      </span>
                    </div>
                    <div class="de-table-col">
                        <span class="line-40" style="line-height: 40px">
                        <el-input type="number" v-model.number="entpHeavyPollInfo.emissionDust" :min="1" size="small" style="width:80px;"></el-input>
                      </span>
                    </div>
                    <div class="de-table-col">
                        <span class="line-40" style="line-height: 40px">
                        <el-input type="number" v-model.number="entpHeavyPollInfo.emissionNOx" :min="1" size="small" style="width:80px;"></el-input>
                      </span>
                    </div>
                    <div class="de-table-col">
                        <span class="line-40" style="line-height: 40px">
                        <el-input type="number" v-model.number="entpHeavyPollInfo.emissionVOCs" :min="1" size="small" style="width:80px;"></el-input>
                      </span>
                    </div>
                    <div class="de-table-col">
                        <span class="line-40" style="line-height: 40px">
                        <el-input type="number" v-model.number="entpHeavyPollInfo.emissionTotal" disabled size="small" :controls='false' style="width:80px;"></el-input>
                      </span>
                    </div>
                </div>
            </div>
            <div class="de-table-bot">
                <div class="de-table-bot-head" style="border-right:1px solid #ccc;">
                    <span class="line-25" style="line-height: 25px">减排量</span>
                </div>
                <div class="de-table-bot-con">
                    <div class="de-table-col">
                        <div class="de-table-row" v-for="(item10,index) in currentStrategy_three.measure" :key="'10'+index">
                            <span class="line-100" style="line-height: 100px">
                          <el-input type="number" v-model.number="item10.expectSO2" :min="0" size="small"  style="width:80px;"></el-input>
                        </span>
                        </div>
                        <div class="de-table-row" v-for="(item11,index) in currentStrategy_two.measure" :key="'11'+index">
                            <span class="line-100" style="line-height: 100px">
                          <el-input type="number" v-model.number="item11.expectSO2" :min="0" size="small"  style="width:80px;"></el-input>
                        </span>
                        </div>
                        <div class="de-table-row" v-for="(item12,index) in currentStrategy_one.measure" :key="'12'+index">
                            <span class="line-100" style="line-height: 100px">
                          <el-input type="number" v-model.number="item12.expectSO2" :min="0" size="small"  style="width:80px;"></el-input>
                        </span>
                        </div>
                    </div>
                    <div class="de-table-col">
                        <div class="de-table-row" v-for="(item14,index) in currentStrategy_three.measure" :key="'14'+index">
                            <span class="line-100" style="line-height: 100px">
                          <el-input type="number" v-model.number="item14.expectDust" :min="0" size="small"  style="width:80px;"></el-input>
                        </span>
                        </div>
                        <div class="de-table-row" v-for="(item15,index) in currentStrategy_two.measure" :key="'15'+index">
                            <span class="line-100" style="line-height: 100px">
                          <el-input type="number" v-model.number="item15.expectDust" :min="0" size="small"  style="width:80px;"></el-input>
                        </span>
                        </div>
                        <div class="de-table-row" v-for="(item16,index) in currentStrategy_one.measure" :key="'16'+index">
                            <span class="line-100" style="line-height: 100px">
                          <el-input type="number" v-model.number="item16.expectDust" :min="0" size="small"  style="width:80px;"></el-input>
                        </span>
                        </div>
                    </div>
                    <div class="de-table-col">
                        <div class="de-table-row" v-for="(item18,index) in currentStrategy_three.measure" :key="'18'+index">
                            <span class="line-100" style="line-height: 100px">
                          <el-input type="number" v-model.number="item18.expectNOx" :min="0" size="small"  style="width:80px;"></el-input>
                        </span>
                        </div>
                        <div class="de-table-row" v-for="(item19,index) in currentStrategy_two.measure" :key="'19'+index">
                            <span class="line-100" style="line-height: 100px">
                          <el-input type="number" v-model.number="item19.expectNOx" :min="0" size="small"  style="width:80px;"></el-input>
                        </span>
                        </div>
                        <div class="de-table-row" v-for="(item20,index) in currentStrategy_one.measure" :key="'20'+index">
                            <span class="line-100" style="line-height: 100px">
                          <el-input type="number" v-model.number="item20.expectNOx" :min="0" size="small"  style="width:80px;"></el-input>
                        </span>
                        </div>
                    </div>
                    <div class="de-table-col">
                        <div class="de-table-row" v-for="(item22,index) in currentStrategy_three.measure" :key="'22'+index">
                            <span class="line-100" style="line-height: 100px">
                          <el-input type="number" v-model.number="item22.expectVOCs" :min="0" size="small"  style="width:80px;"></el-input>
                        </span>
                        </div>
                        <div class="de-table-row" v-for="(item23,index) in currentStrategy_two.measure" :key="'23'+index">
                            <span class="line-100" style="line-height: 100px">
                          <el-input type="number" v-model.number="item23.expectVOCs" :min="0" size="small"  style="width:80px;"></el-input>
                        </span>
                        </div>
                        <div class="de-table-row" v-for="(item24,index) in currentStrategy_one.measure" :key="'24'+index">
                            <span class="line-100" style="line-height: 100px">
                          <el-input type="number" v-model.number="item24.expectVOCs" :min="0" size="small"  style="width:80px;"></el-input>
                        </span>
                        </div>
                    </div>
                    <div class="de-table-col">
                        <div class="de-table-row" v-for="(item26,index) in currentStrategy_three.measure" :key="'26'+index">
                            <span class="line-100" style="line-height: 100px">
                          <el-input type="number" v-model.number="item26.expectTotal" :min="0" size="small" disabled :controls='false' style="width:60px;"></el-input>
                        </span>
                        </div>
                        <div class="de-table-row" v-for="(item27,index) in currentStrategy_two.measure" :key="'27'+index">
                            <span class="line-100" style="line-height: 100px">
                          <el-input type="number" v-model.number="item27.expectTotal" :min="0" size="small" disabled :controls='false' style="width:60px;"></el-input>
                        </span>
                        </div>
                        <div class="de-table-row" v-for="(item28,index) in currentStrategy_one.measure" :key="'28'+index">
                            <span class="line-100" style="line-height: 100px">
                          <el-input type="number" v-model.number="item28.expectTotal" :min="0" size="small" disabled :controls='false' style="width:60px;"></el-input>
                        </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import emissTable from "../../components/weather/emissTable";
import measureTable from "../../components/weather/measureTable";
import emer from "../../data/emer/weather.js";
export default {
    props:{
        changeFalse: {
            type: Boolean,
            default: false
        },
        emissionData:{

        }
    },
    data() {
        return {
            isMStop: false,
            measuresOptions: [{
                    value: 3,
                    label: "非强制性措施"
                },
                {
                    value: 1,
                    label: "临时管控"
                },
                {
                    value: 2,
                    label: "轮流停产"
                }
            ],
            fillForm: {
                // 行业类型
                industryType: "",
                // 排放数据
                emissionData: [],
                // 是否免减排企业，
                isAvoid: false,
                // 预案ID
                planId: "",
                // 是否属于建成区内
                isUrban: false,
                // 是否错峰生产
                isStagger: false,
            },
            switchState: true,
            entpHeavyPollInfo: {
                // 数据表信息
                emissionSO2: 100,
                emissionDust: 100,
                emissionNOx: 100,
                emissionTotal: 400,
                emissionVOCs: 100,
                strategy: [],
            },
            currentStrategy_one: {
                // 一级
                level: 1,
                measure: [{
                    cesRateDust: 0,
                    cesRateNOx: 0,
                    cesRateSO2: 0,
                    cesRateTotal: 0,
                    cesRateVOCs: 0,
                    expectDust: 0,
                    expectNOx: 0,
                    expectSO2: 0,
                    expectTotal: 0,
                    expectVOCs: 0,
                    isVehicleControl: false,
                    method: "",
                    strategyType: 3
                }]
            },
            currentStrategy_two: {
                // 二级
                level: 2,
                measure: [{
                    cesRateDust: 0,
                    cesRateNOx: 0,
                    cesRateSO2: 0,
                    cesRateTotal: 0,
                    cesRateVOCs: 0,
                    expectDust: 0,
                    expectNOx: 0,
                    expectSO2: 0,
                    expectTotal: 0,
                    expectVOCs: 0,
                    isVehicleControl: false,
                    method: "",
                    strategyType: 3
                }]
            },
            currentStrategy_three: {
                // 三级
                level: 3,
                measure: [{
                    cesRateDust: 0,
                    cesRateNOx: 0,
                    cesRateSO2: 0,
                    cesRateTotal: 0,
                    cesRateVOCs: 0,
                    expectDust: 0,
                    expectNOx: 0,
                    expectSO2: 0,
                    expectTotal: 0,
                    expectVOCs: 0,
                    isVehicleControl: false,
                    method: "",
                    strategyType: 3
                },]
            },
        };
    },
    watch: {
        emissionData: {
            handler() {
                this.entpHeavyPollInfo = {
                    // 数据表信息
                    emissionSO2: this.emissionData.emissionSO2,
                    emissionDust: this.emissionData.emissionDust,
                    emissionNOx: this.emissionData.emissionNOx,
                    emissionTotal: this.emissionData.emissionTotal,
                    emissionVOCs: this.emissionData.emissionVOCs,
                    strategy: this.emissionData.strategy,
                }
                this.currentStrategy_one = this.emissionData.strategy.find((data) => data.level == 1);
                this.currentStrategy_two = this.emissionData.strategy.find((data) => data.level == 2);
                this.currentStrategy_three = this.emissionData.strategy.find((data) => data.level == 3);
            },
            deep: true
        },
        "entpHeavyPollInfo.emissionDust": {
            handler() {
                this.numberChange();
            },
            deep: true
        },
        "entpHeavyPollInfo.emissionNOx": {
            handler() {
                this.numberChange();
            },
            deep: true
        },
        "entpHeavyPollInfo.emissionSO2": {
            handler() {
                this.numberChange();
            },
            deep: true
        },
        "entpHeavyPollInfo.emissionVOCs": {
            handler() {
                this.numberChange();
            },
            deep: true
        },
        "currentStrategy_three.measure": {
            handler() {
                this.numberChange();
            },
            deep: true
        },
        "currentStrategy_two.measure": {
            handler() {
                this.numberChange();
            },
            deep: true
        },
        "currentStrategy_one.measure": {
            handler() {
                this.numberChange();
            },
            deep: true
        },
        changeFalse() {
            this.changeFalse == true ?
                (this.fillForm.isAvoid = true) :
                (this.fillForm.isAvoid = false);
        }
    },
  mounted() {
    this.submitForm();
  },
  methods: {
        numberChange() {
            let total =
                this.entpHeavyPollInfo.emissionDust +
                this.entpHeavyPollInfo.emissionNOx +
                this.entpHeavyPollInfo.emissionSO2 +
                this.entpHeavyPollInfo.emissionVOCs;
            this.currentStrategy_three.measure[0].expectTotal =
                this.currentStrategy_three.measure[0].expectSO2 +
                this.currentStrategy_three.measure[0].expectDust +
                this.currentStrategy_three.measure[0].expectNOx +
                this.currentStrategy_three.measure[0].expectVOCs;
            this.currentStrategy_two.measure[0].expectTotal =
                this.currentStrategy_two.measure[0].expectSO2 +
                this.currentStrategy_two.measure[0].expectDust +
                this.currentStrategy_two.measure[0].expectNOx +
                this.currentStrategy_two.measure[0].expectVOCs;
            this.currentStrategy_one.measure[0].expectTotal =
                this.currentStrategy_one.measure[0].expectSO2 +
                this.currentStrategy_one.measure[0].expectDust +
                this.currentStrategy_one.measure[0].expectNOx +
                this.currentStrategy_one.measure[0].expectVOCs;
            this.entpHeavyPollInfo.emissionTotal = total;
            this.submitForm();
        },
        changesss() {
            this.entpHeavyPollInfo.strategy[0] = this.currentStrategy_three;
            this.entpHeavyPollInfo.strategy[1] = this.currentStrategy_two;
            this.entpHeavyPollInfo.strategy[2] = this.currentStrategy_one;
            this.fillForm.planId = sessionStorage.planIdval;
            this.fillForm.emissionData[0] = this.entpHeavyPollInfo;
        },
        submitForm(formName) {
            this.changesss();
            if (
                this.entpHeavyPollInfo.emissionSO2 <
                this.currentStrategy_three.measure[0].expectSO2 ||
                this.entpHeavyPollInfo.emissionSO2 <
                this.currentStrategy_two.measure[0].expectSO2 ||
                this.entpHeavyPollInfo.emissionSO2 <
                this.currentStrategy_one.measure[0].expectSO2
            ) {
                this.$message.error("二氧化硫减排量必须小于日排放量");
                return false;
            }
            if (
                this.entpHeavyPollInfo.emissionDust <
                this.currentStrategy_three.measure[0].expectDust ||
                this.entpHeavyPollInfo.emissionDust <
                this.currentStrategy_two.measure[0].expectDust ||
                this.entpHeavyPollInfo.emissionDust <
                this.currentStrategy_one.measure[0].expectDust
            ) {
                this.$message.error("烟、粉尘减排量必须小于日排放量");
                return false;
            }
            if (
                this.entpHeavyPollInfo.emissionNOx <
                this.currentStrategy_three.measure[0].expectNOx ||
                this.entpHeavyPollInfo.emissionNOx <
                this.currentStrategy_two.measure[0].expectNOx ||
                this.entpHeavyPollInfo.emissionNOx <
                this.currentStrategy_one.measure[0].expectNOx
            ) {
                this.$message.error("氮氧化物减排量必须小于日排放量");
                return false;
            }
            if (
                this.entpHeavyPollInfo.emissionVOCs <
                this.currentStrategy_three.measure[0].expectVOCs ||
                this.entpHeavyPollInfo.emissionVOCs <
                this.currentStrategy_two.measure[0].expectVOCs ||
                this.entpHeavyPollInfo.emissionVOCs <
                this.currentStrategy_one.measure[0].expectVOCs
            ) {
                this.$message.error("VOCs减排量必须小于日排放量");
                return false;
            }
            this.$emit("change", this.fillForm);
        }
    },
    components: {
        emissTable,
        measureTable
    }
};
</script>

<style>
/* 公共样式 */

.line-25 {
    line-height: 25px;
}

.line-30 {
    line-height: 30px;
}

.line-35 {
    line-height: 35px;
}

.line-40 {
    line-height: 40px;
}

.line-100 {
    line-height: 100px;
}

.de-table-wrap {
    width: 100%;
    height: 100%;
    position: relative;
    display: inline-flex;
    background: #fff;
    text-align: center;
    font-size: 14px;
}

.de-table-wrap span {
    width: 100%;
    height: 100%;
    text-align: center;
    color: #333;
}

.de-table-lt {
    flex: 1;
    background: #fff;
    display: flex;
    flex-direction: column;
    border: 1px solid #ccc;
    border-top: 0;
}

.de-table-ct {
    flex: 8;
    border-right: 1px solid #ccc;
    display: flex;
    flex-direction: column;
}

.de-table-rt {
    flex: 6;
    display: flex;
    flex-direction: column;
}

.de-table-top {
    /* flex: 1; */
    border-bottom: 1px solid #ccc;
    border-top: 1px solid #ccc;
    display: flex;
    flex-direction: column;
}

.de-table-top-head {
    /* flex: 1; */
    height: 40px;
    border-bottom: 1px solid #ccc;
    display: flex;
}

.de-table-top-list {
    /*flex: 1;*/
    height: 40px;
    display: flex;
}

.de-table-bot {
    flex: 3;
    display: flex;
    flex-direction: column;
}

.de-table-bot-head {
    /* flex: 1; */
    height: 40px;
    border-bottom: 1px solid #ccc;
    display: flex;
}

.de-table-bot-con {
    flex: 5;
    display: flex;
}

.de-table-col {
    flex: 1;
    border-right: 1px solid #ccc;
    display: flex;
    flex-direction: column;
}

.de-table-row {
    flex: 1;
    box-sizing: border-box;
    display: flex;
    border-bottom: 1px solid #ccc;
}

.bd-none {
    border-right: 0;
}

.bg-red {
    background: red;
    border: 1px solid red;
}

.el-textarea__inner {
    padding: 0px !important;
    height: 100% !important;
    border:none;
    padding:10px !important;
}

.noheating .el-input--small .el-input__inner {
    border:none;
}

.flex125 {
    flex:1.25;
}

.flex5 {
    flex:5;
}

.flex1 {
    flex:1;
}

</style>



// WEBPACK FOOTER //
// noheating1.vue?658b4de1